/* Flatline Wishlist: swap the app's hearts for the rebrand artwork (16px mobile, 32px desktop).
   Each heart is a solid shape (saved fill) under a ring (outline) so both can be coloured separately. */
(function () {
  var SHAPES = {
    16: {
      fill: 'M8 3.58594L9.58594 2H13.4141L15 3.58594V8.41406L9.41406 14H6.58594L1 8.41406V3.58594L2.58594 2H6.41406L8 3.58594Z',
      ring: 'M8 3.58594L9.58594 2H13.4141L15 3.58594V8.41406L9.41406 14H6.58594L1 8.41406V3.58594L2.58594 2H6.41406L8 3.58594ZM3 4.41406V7.58594L7.41406 12H8.58594L13 7.58594V4.41406L12.5859 4H10.4141L9 5.41406V7H7V5.41406L5.58594 4H3.41406L3 4.41406Z'
    },
    32: {
      fill: 'M16 6.92773L18.3672 4.5H25.6328L29.0742 8.0293L29.5 8.4668V17.3799L19.6328 27.5H12.3672L2.5 17.3799V8.4668L2.92578 8.0293L6.36719 4.5H13.6328L16 6.92773Z',
      ring: 'M16 6.92773L18.3672 4.5H25.6328L29.0742 8.0293L29.5 8.4668V17.3799L19.6328 27.5H12.3672L2.5 17.3799V8.4668L2.92578 8.0293L6.36719 4.5H13.6328L16 6.92773ZM5.5 9.68652V16.1582L13.6328 24.5H18.3672L26.5 16.1582V9.68652L24.3672 7.5H19.6328L17.5 9.68652V13.6924H14.5V9.68652L12.3672 7.5H7.63281L5.5 9.68652Z'
    }
  };

  function heart(size) {
    var s = SHAPES[size];
    return '<svg class="rgl-heart rgl-heart--' + size + '" viewBox="0 0 ' + size + ' ' + size + '" aria-hidden="true" focusable="false">' +
      '<path class="rgl-heart__fill" d="' + s.fill + '"/>' +
      '<path class="rgl-heart__ring" fill-rule="evenodd" clip-rule="evenodd" d="' + s.ring + '"/></svg>';
  }

  var MARKUP = heart(16) + heart(32);

  function applyIcons() {
    document.querySelectorAll('.header__wishlist-link .wishlist-header__icon, .wishlist-button__icon').forEach(function (icon) {
      if (icon.querySelector('.rgl-heart')) return;
      icon.innerHTML = MARKUP;
    });
  }

  function init() {
    applyIcons();
    new MutationObserver(applyIcons).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
